export const cssSizes = `
  // Semantic sizes
  --card-padding: 18px;
`;
